import { SVGProps } from 'react';

const SvgHandHoldingDroplet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M275.5 6.6C278.3 2.5 283 0 288 0s9.7 2.5 12.5 6.6l66.3 96.4c11.2 16.3 17.2 35.6 17.2 55.3v1.7c0 53-43 96-96 96s-96-43-96-96v-1.7c0-19.8 6-39 17.2-55.3l66.3-96.4zM187.4 352c-7.9 0-15.6 2.3-22.2 6.7L85.3 412c-3.9 2.6-8.6 4-13.3 4H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h40.7l73.8-49.2C153 309.1 170 304 187.4 304H344c35.3 0 64 28.7 64 64v2l64.9-40c10.7-6.6 22.9-10 35.5-10h7.4c33.3 0 60.3 27 60.3 60.3 0 20.4-10.4 39.5-27.5 50.6L453 492.8c-19.4 12.6-42.1 19.3-65.2 19.3H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h363.7c13.9 0 27.5-4 39.1-11.6l95.6-61.9c3.5-2.3 5.6-6.1 5.6-10.3 0-6.8-5.5-12.3-12.3-12.3h-7.4c-3.6 0-7.2 1-10.3 2.9l-93.5 57.5c-3.8 2.3-8.1 3.6-12.6 3.6H256c-13.3 0-24-10.7-24-24s10.7-24 24-24h88c8.8 0 16-7.2 16-16s-7.2-16-16-16H187.4z" />
  </svg>
);
export default SvgHandHoldingDroplet;
